module.exports = __webpack_public_path__ + "img/customer_2.48512dff.png";